module.exports = __webpack_public_path__ + "static/media/drag-loading.ddd58f0b.png";